require('./accountDirectDebitErrorStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');

class AccountDirectDebitErrorStep extends React.Component {
    render() {
        const { selectedAccountId } = this.props;
        const goBackButtonLabel = <FormattedText value="accountDirectDebitSuccess-mainButton" format="uppercase"/>;
        const linkToDetails = `/myprofile/accounts/${selectedAccountId}/debits`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };

        return (
            <div className="account-direct-debit-error col-xs-9 center-block">
                <WizardError
                    errorMessage={formatText('accountDirectDebitError-title')}
                    mainButton={mainButton}
                >
                    <div className="account-direct-debit-error__content">
                        <FormattedText value="accountDirectDebitError-content"/>
                    </div>
                </WizardError>
            </div>
        );
    }
}

AccountDirectDebitErrorStep.propTypes = {
    selectedAccountId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired
};

module.exports = AccountDirectDebitErrorStep;
